/* @flow */
import Subscriber from 'entities/Subscriber';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';

class Subscribers extends Collection {
  initialize() {
    this.url = '/subscribers';
    this.model = Subscriber;
  }

  comparator(a: Subscriber, b: Subscriber) {
    return a.getName().localeCompare(b.getName());
  }

  sortByFirstName() {
    return this.sortBy(subscriber => {
      return `${subscriber.getFirstName()} ${subscriber.getLastName()}`.toLowerCase();
    });
  }

  sortByLastName() {
    return this.sortBy(subscriber => {
      return `${subscriber.getLastName()}, ${subscriber.getFirstName()}`.toLowerCase();
    });
  }

  sortBySubscribedAt() {
    return this.sortBy(subscriber => {
      return -subscriber.getSubscribedAt();
    });
  }

  static export(groupIds) {
    return apiRequest('/subscribers/export', 'POST', {
      group_ids: groupIds,
    });
  }
}

export default Subscribers;



// WEBPACK FOOTER //
// ./src/collections/Subscribers.js